import React from "react"
import { motion } from "framer-motion"
import SectionTitle from "../common/SectionTitle"
import Button from "../common/Button"

export default function GalleryPreview() {
  const galleryImages = [
    {
      id: 1,
      image: "/images/gallery-1.jpg",
      title: "Chambre Massage Luxe",
    },

    {
      id: 2,
      image: "/images/gallery-2.jpg",
      title: "Experience Hammam Luxe",
    },

    {
      id: 3,
      image: "/images/gallery-3.jpg",
      title: "Soins Visage Premium",
    },

    {
      id: 4,
      image: "/images/gallery-4.jpg",
      title: "Bien-être et Relaxation",
    },
  ]

  return (
    <section className="py-20 lg:py-28 bg-[#f9f6f1] overflow-hidden">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Title */}
        <SectionTitle
          subtitle="Notre Galerie"
          title="Découvrez La Beauté De Notre Expérience Spa"
          description="Découvrez l'atmosphère paisible, les espaces luxueux et les expériences de bien-être haut de gamme qui font de notre spa un lieu véritablement exceptionnel."
        />

        {/* Gallery Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 mt-16">
          {galleryImages.map((item, index) => (
            <motion.div
              key={item.id}
              initial={{ opacity: 0, y: 60 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.7, delay: index * 0.15 }}
              viewport={{ once: true }}
              className={`group relative overflow-hidden rounded-[28px] shadow-xl ${
                index === 1 || index === 2
                  ? "lg:mt-12"
                  : ""
              }`}
            >
              {/* Image */}
              <div className="h-[420px] overflow-hidden">
                <img
                  src={item.image}
                  alt={item.title}
                  loading="lazy"
                  className="w-full h-full object-cover group-hover:scale-110 transition duration-700"
                />
              </div>

              {/* Overlay */}
              <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/20 to-transparent opacity-90" />

              {/* Content */}
              <div className="absolute bottom-0 left-0 w-full p-6">
                <span className="inline-block text-[#d6b57b] uppercase tracking-[3px] text-xs mb-3">
                  Spa Bien-être
                </span>

                <h3 className="text-white text-2xl font-semibold leading-snug">
                  {item.title}
                </h3>
              </div>
            </motion.div>
          ))}
        </div>

        {/* Bottom CTA */}
        <motion.div
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          viewport={{ once: true }}
          className="mt-16 text-center"
        >
          <Button
            to="/galerie"
            size="lg"
            variant="primary"
            ariaLabel="Voir la galerie du spa"
          >
            Explorer la galerie
          </Button>
        </motion.div>
      </div>
    </section>
  )
}